module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@2x-00bee50bfb83513f7564fc922cfbf7ce.png";